import React, { useState } from 'react';
import styles from './App.module.less';
import IntroSection from './components/IntroSection';
import CMESearchForm from './components/CMESearchForm';
import CMEResults from './components/CMEResults';
import OhioMapViewer from './components/OhioMapViewer';
import { useCMEData } from './hooks/useCMEData';
import { 
  getCountyPath, 
  getCountyByZipcode,
  filterCountiesByQuery,
  filterZipcodesByQuery 
} from './utils/countyUtils';
import { OHIO_COUNTIES } from './constants';

function App() {
  // Load CME data using custom hook
  const { data, loading, error } = useCMEData();

  // State management
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const [selectedCounty, setSelectedCounty] = useState('');
  const [filteredCounties, setFilteredCounties] = useState(null);
  const [showZipcodeInput, setShowZipcodeInput] = useState(false);
  const [autocompleteZipcodeValue, setAutocompleteZipcodeValue] = useState(null);
  const [filteredZipcodes, setFilteredZipcodes] = useState(null);

  // Event handlers
  const handleAutocompleteSearch = (event) => {
    const filtered = filterCountiesByQuery(event.query);
    setFilteredCounties(filtered);
  };

  const handleAutocompleteZipcodeSearch = (event) => {
    const filtered = filterZipcodesByQuery(event.query);
    setFilteredZipcodes(filtered);
  };

  const handleSubmit = () => {
    if (!getCountyPath(autocompleteValue)) return;

    const countyEntry = OHIO_COUNTIES.find(entry => entry[0] === autocompleteValue);
    const zipcodes = countyEntry?.[2];

    if (zipcodes && !autocompleteZipcodeValue) {
      setShowZipcodeInput(true);
    } else if (zipcodes && autocompleteZipcodeValue) {
      const countyByZip = getCountyByZipcode(autocompleteZipcodeValue);
      setAutocompleteValue(countyByZip);
      setSelectedCounty(countyByZip);
    } else {
      setSelectedCounty(autocompleteValue);
    }
  };

  const handleBackToSearch = () => {
    setShowZipcodeInput(false);
    setAutocompleteValue(null);
    setAutocompleteZipcodeValue(null);
    setSelectedCounty('');
  };

  const handleCountyClick = (countyName) => {
    setSelectedCounty(countyName);
  };

  return (
    <div className={styles.App}>
      <div className={styles.appWrapper}>
        <IntroSection />

        {loading && (
            <div className={styles.App}>
              <div className={styles.appWrapper}>
                <div className={styles.loading}>Loading CME data...</div>
              </div>
            </div>
          )
        }

        {error && (
            <div className={styles.App}>
              <div className={styles.appWrapper}>
                <div className={styles.error}>Error loading data. Please refresh the page.</div>
              </div>
            </div>
          )
        }

        {!loading && !error && (
          <div className={styles.cmeSearch}>
            <div className={styles.form}>
              {selectedCounty ? (
                <CMEResults
                  selectedCounty={selectedCounty}
                  cmeData={data}
                  onBackToSearch={handleBackToSearch}
                />
              ) : (
                <CMESearchForm
                  autocompleteValue={autocompleteValue}
                  setAutocompleteValue={setAutocompleteValue}
                  filteredCounties={filteredCounties}
                  onAutocompleteSearch={handleAutocompleteSearch}
                  showZipcodeInput={showZipcodeInput}
                  autocompleteZipcodeValue={autocompleteZipcodeValue}
                  setAutocompleteZipcodeValue={setAutocompleteZipcodeValue}
                  filteredZipcodes={filteredZipcodes}
                  onAutocompleteZipcodeSearch={handleAutocompleteZipcodeSearch}
                  onSubmit={handleSubmit}
                />
              )}
            </div>

            <OhioMapViewer
              selectedCounty={selectedCounty}
              onCountyClick={handleCountyClick}
              cmeData={data}
            />
          </div>
        )
      }
      </div>
    </div>
  );
}

export default App;